module.exports = __webpack_public_path__ + "img/pit1.cc281402.webp";